import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Container,
  CardContent,
  Divider,
  MenuItem,
  Grid,
  InputLabel,
  TextField,
  CardHeader,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import { useAlert } from 'react-alert';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { LoadingComponent } from 'src/utils/newLoader';
import { forEach } from 'lodash';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  btnReject: {
    backgroundColor: "red",
    marginRight: "1rem",
  },
  btnSendToDel: {
    backgroundColor: "#FF9800",
    marginRight: "1rem",
  },
  btnIssue: {
    backgroundColor: "green",
  },
  btnSearch: {
    marginRight: "1rem",
  },
  btnSendToApprove: {
    backgroundColor: "green",
    marginRight: "1rem",
  },
}));

const screenCode = 'APPROVEFACTORYITEMISSUE';
export default function ApproveFactoryItemIssueListing(props) {
  const classes = useStyles();
  const [title, setTitle] = useState('Approve Factory Item Issue');
  const componentRef = useRef([]);
  const [factoryAdjustmentData, setFactoryAdjustmentData] = useState([]);
  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState([]);
  const [routes, setRoutes] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
  const [fromDate, handleFromDate] = useState(new Date());
  const [toDate, handleToDate] = useState(new Date());
  const [selectedRows, setSelectedRows] = useState([]);
  const [allDataList, setAllDataList] = useState([]);
  const [selectedRequestNumbers, setSelectedRequestNumbers] = useState([]);
  const [GRNList, setGRNList] = useState([]);
  const [availableGRNQuatitiyData, setAvailableGRNQuatitiyData] = useState([]);
  const [insufficientStockItems, setInsufficientStockItems] = useState([]);
  const [requestList, setAdjustmentList] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0',
    requestType: '0',
    statusID: '0'
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '0',
    factoryName: '0'
  });
  const [factoryItemRequestData, setFactoryItemRequestData] = useState([]);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [warningDialogOpen, setWarningDialogOpen] = useState(false);

  const navigate = useNavigate();

  const alert = useAlert();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  useEffect(() => {
    const IDdata = JSON.parse(
      sessionStorage.getItem('FCT-listing-page-search-parameters-id')
    );
    getPermission(IDdata);
    if (IDdata != null) {
      getSelectedDropdownValuesForReport(IDdata);
    }
    setPage(0);
  }, []);

  useEffect(() => {
    sessionStorage.removeItem('FCT-listing-page-search-parameters-id');
  }, []);

  useEffect(() => {
    if (IDDataForDefaultLoad != null) {
      GetDetails();
    }
  }, [IDDataForDefaultLoad]);

  useEffect(() => {
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getfactoriesForDropDown());
  }, [requestList.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [requestList.factoryID]);

  async function getPermission(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWAPPROVEFACTORYITEMISSUE'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const isInitialLoad = IDdata === null;
    if (isInitialLoad) {
      setAdjustmentList({
        ...requestList,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      });
    } else {
      setAdjustmentList({
        ...requestList,
        groupID: IDdata.groupID,
        factoryID: IDdata.factoryID,
        routeID: IDdata.routeID,
        requestType: IDdata.requestType,
        statusID: IDdata.statusID,
        factoryItemID: IDdata.factoryItemID
      });
      handleFromDate(IDdata.fromDate);
      handleToDate(IDdata.toDate);
      setPage(IDdata.page);
      setIsIDDataForDefaultLoad(IDdata);
    }
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(
      requestList.factoryID
    );
    setRoutes(routeList);
  }

  async function getfactoriesForDropDown() {
    const factory = await services.getfactoriesForDropDown(requestList.groupID);
    setFactories(factory);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function GetDetails() {
    let model = {
      groupID: parseInt(requestList.groupID),
      factoryID: parseInt(requestList.factoryID),
      routeID: parseInt(requestList.routeID),
      requestType: parseInt(requestList.requestType),
      statusID: parseInt(requestList.statusID),
      startDate: fromDate,
      endDate: toDate
    };

    if (IDDataForDefaultLoad == null) {
      getSelectedDropdownValuesForReport(model);
    }
    setIsIDDataForDefaultLoad(null);
    const customerData = await services.GetFactoryItemRequestDetails(model);
    setGRNList(customerData);
    setPage(0);
    setPageSize(5);
    if (customerData.data) {
      const grnResults = [];

      for (const item of customerData.data) {
        const model = {
          factoryItemID: item.factoryItemID,
          supplierID: item.supplierID
        };

        const grnResponse = await services.GetFactoryItemGRNListByFactoryItemIDAndSupplierID(model.factoryItemID, model.supplierID);

        if (grnResponse.length > 0 && grnResponse[0]?.availableQuantity !== undefined) {
          grnResults.push({
            factoryItemID: model.factoryItemID,
            supplierID: model.supplierID,
            availableQuantity: grnResponse[0].availableQuantity
          });
        } else {
          grnResults.push({
            factoryItemID: model.factoryItemID,
            supplierID: model.supplierID,
            availableQuantity: 0
          });
        }
      }
      setAvailableGRNQuatitiyData(grnResults);
    }

    if (customerData.statusCode == 'Success' && customerData.data != null) {

      const groupedData = groupAndSumByRequestNumber(customerData.data);
      setAllDataList(groupedData);
      setFactoryAdjustmentData(groupedData);

      if (groupedData.length == 0) {
        alert.error('No records to display');
      }
    } else {
      alert.error('Error');
    }
  }

  function getSelectedDropdownValuesForReport(requestList) {
    const selectedGroupName =
      groups && requestList.groupID in groups
        ? groups[requestList.groupID]
        : '--Select Group--';
    const selectedFactoryName =
      factories && requestList.factoryID in factories
        ? factories[requestList.factoryID]
        : '--Select Factory--';

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: selectedGroupName,
      factoryName: selectedFactoryName
    });
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setAdjustmentList({
      ...requestList,
      [e.target.name]: value
    });
    setFactoryAdjustmentData([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  function handleClickEdit(rowData) {
    const selectedRecords = allDataList.filter(
      item => item.requestNumber === rowData.requestNumber
    );
    setFactoryItemRequestData(selectedRecords);
    setViewDialogOpen(true);
  }

  async function handleApprove(selectedRows) {
    if (selectedRows.length === 0) {
      alert.error('Please select at least one item to approve');
      return;
    }

    const requestedItemsMap = new Map();
    selectedRows.forEach((row) => {
      if (row.statusID === 1) {
        row.factoryItemDetailsList.forEach((item) => {
          const key = `${item.factoryItemID}-${item.supplierID}`;
          const existing = requestedItemsMap.get(key) || {
            factoryItemID: item.factoryItemID,
            supplierID: item.supplierID,
            itemName: item.itemName,
            supplierName: item.supplierName,
            totalRequested: 0,
            availableQuantity: 0,
            requestNumbers: new Set(),
          };

          existing.totalRequested += item.requestedItemTotalQuantity;
          existing.requestNumbers.add(row.requestNumber);
          requestedItemsMap.set(key, existing);
        });
      }
    });

    const insufficientItems = [];

    for (const [key, requestedItem] of requestedItemsMap) {
      const grnItem = availableGRNQuatitiyData.find(
        (grn) =>
          grn.factoryItemID === requestedItem.factoryItemID &&
          grn.supplierID === requestedItem.supplierID
      );

      const availableQty = grnItem?.availableQuantity || 0;
      requestedItem.availableQuantity = availableQty;

      if (requestedItem.totalRequested > availableQty) {
        insufficientItems.push({
          ...requestedItem,
          requestNumbers: Array.from(requestedItem.requestNumbers),
        });
      }
    }

    if (insufficientItems.length > 0) {
      setWarningDialogOpen(true);
      setInsufficientStockItems(insufficientItems);
      return;
    }

    const result = await services.ApproveFactoryItems(selectedRows);

    if (result.statusCode === 'Success') {
      alert.success('Items approved successfully');
      await GetDetails();
      setSelectedRows([]);
    } else {
      alert.error(result.message || 'Approval failed');
    }
  }

  async function handleReject(selectedRows) {
    if (selectedRows.length === 0) {
      alert.error('Please select at least one item to approve');
      return;
    }

    const result = await services.rejectFactoryItems(selectedRows);
    if (result.statusCode === 'Success') {
      alert.success('Items rejected successfully');
      GetDetails();
      setSelectedRows([]);
    } else {
      alert.error(result.message || 'Rejection failed');
    }
  }

  function groupAndSumByRequestNumber(data) {
    const groupedData = {};

    data.forEach(item => {
      if (!groupedData[item.requestNumber]) {
        groupedData[item.requestNumber] = {
          ...item,
          paymentEffectiveDate: item.effectiveDate,
          noOfInstalments: item.noOfInstallments,
          customerRegistrationNumber: item.customerRegistrationNumber,
          statusTypeID: item.statusID,
          groupID: parseInt(requestList.groupID),
          modifiedBy: tokenService.getUserIDFromToken(),
          FactoryID: parseInt(requestList.factoryID),
          CreatededDate: new Date().toISOString(),
          requestedItemTotalPrice: parseFloat(item.totalPrice) || 0,
          requestedItemTotalQuantity: item.requestedItemTotalQuantity,
          factoryItemDetailsList: [{
            effectiveDate: item.effectiveDate,
            issuingDate: item.issuingDate,
            routeName: item.routeName,
            customerRegistrationNumber: item.customerRegistrationNumber,
            factoryItemID: item.factoryItemID,
            FactoryItemRequestID: item.factoryItemRequestID,
            itemName: item.itemName,
            approvedQuantity: item.requestedItemTotalQuantity,
            unitPrice: item.totalPrice,
            supplierID: item.supplierID,
            supplierName: item.supplierName,
            noOfInstallments: item.noOfInstallments,
            statusID: item.statusID,
            requestedItemTotalQuantity: item.requestedItemTotalQuantity,
          }]
        };
      } else {
        groupedData[item.requestNumber].requestedItemTotalPrice += parseFloat(item.totalPrice) || 0;
        groupedData[item.requestNumber].factoryItemDetailsList.push({
          effectiveDate: item.effectiveDate,
          issuingDate: item.issuingDate,
          routeName: item.routeName,
          customerRegistrationNumber: item.customerRegistrationNumber,
          factoryItemID: item.factoryItemID,
          FactoryItemRequestID: item.factoryItemRequestID,
          itemName: item.itemName,
          approvedQuantity: item.requestedItemTotalQuantity,
          unitPrice: item.totalPrice,
          supplierID: item.supplierID,
          supplierName: item.supplierName,
          noOfInstallments: item.noOfInstallments,
          statusID: item.statusID,
          requestedItemTotalQuantity: item.requestedItemTotalQuantity,
        });
      }
    });
    return Object.values(groupedData);
  }

  const handleRowSelect = (rowData, isSelected) => {
    if (isSelected) {
      setSelectedRows(prev => [...prev, rowData]);
    } else {
      setSelectedRows(prev =>
        prev.filter(row => row.requestNumber !== rowData.requestNumber)
      );
    }
  };

  const handleSelectAllPending = (isChecked) => {
    if (isChecked) {
      const pendingRows = factoryAdjustmentData.filter(row => row.statusID === 1);
      setSelectedRows(pendingRows);
    } else {
      setSelectedRows([]);
    }
  };

  const areAllPendingSelected = () => {
    const pendingRows = factoryAdjustmentData.filter(row => row.statusID === 1);
    return pendingRows.length > 0 && pendingRows.every(row =>
      selectedRows.some(selected => selected.requestNumber === row.requestNumber)
    );
  };

  const areSomePendingSelected = () => {
    const pendingRows = factoryAdjustmentData.filter(row => row.statusID === 1);
    const selectedPendingCount = pendingRows.filter(row =>
      selectedRows.some(selected => selected.requestNumber === row.requestNumber)
    ).length;
    return selectedPendingCount > 0 && selectedPendingCount < pendingRows.length;
  };

  const isRowSelected = (rowData) => {
    return selectedRows.some(row => row.requestNumber === rowData.requestNumber);
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title="Factory Item Request Details">
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: requestList.groupID,
              factoryID: requestList.factoryID,
              fromDate: fromDate,
              toDate: toDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required'),
              fromDate: Yup.date()
                .required('From date is required')
                .typeError('Invalid date'),
              toDate: Yup.date()
                .required('To date is required')
                .typeError('Invalid date')
            })}
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({ errors, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent style={{ marginBottom: '2rem' }}>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size="small"
                              onChange={e => handleChange(e)}
                              value={requestList.groupID}
                              variant="outlined"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size="small"
                              onChange={e => handleChange(e)}
                              value={requestList.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel
                              shrink
                              id="fromDate"
                              style={{ marginBottom: '-8px' }}
                            >
                              From Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(
                                  touched.fromDate && errors.fromDate
                                )}
                                helperText={touched.fromDate && errors.fromDate}
                                autoOk
                                fullWidth
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name="fromDate"
                                id="fromDate"
                                value={fromDate}
                                maxDate={toDate}
                                onChange={e => {
                                  handleFromDate(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                InputProps={{ readOnly: true }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel
                              shrink
                              id="toDate"
                              style={{ marginBottom: '-8px' }}
                            >
                              To Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(touched.toDate && errors.toDate)}
                                helperText={touched.toDate && errors.toDate}
                                autoOk
                                fullWidth
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name="toDate"
                                id="toDate"
                                value={toDate}
                                minDate={fromDate}
                                onChange={e => {
                                  handleToDate(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                InputProps={{ readOnly: true }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              size="small"
                              onChange={e => handleChange(e)}
                              value={requestList.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="statusID">
                              Status
                            </InputLabel>

                            <TextField
                              select
                              fullWidth
                              name="statusID"
                              size="small"
                              onChange={e => {
                                handleChange(e);
                              }}
                              value={requestList.statusID}
                              variant="outlined"
                              id="statusID"
                            >
                              <MenuItem value={'0'}>--Select Status--</MenuItem>
                              <MenuItem value={'1'}>Pending</MenuItem>
                              <MenuItem value={'2'}>Approved</MenuItem>
                              <MenuItem value={'3'}>Rejected</MenuItem>
                            </TextField>
                          </Grid>
                        </Grid>
                        <br />
                        <Grid container justify="flex-end">
                          <Box pr={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              type="submit"
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>
                      </CardContent>
                      <Box minWidth={1000}>
                        {factoryAdjustmentData.length > 0 ? (<>
                          <MaterialTable
                            title="Multiple Actions Preview"
                            columns={[
                              {
                                title: (
                                  <Checkbox
                                    checked={areAllPendingSelected()}
                                    indeterminate={areSomePendingSelected()}
                                    onChange={(event) => handleSelectAllPending(event.target.checked)}
                                    color="primary"
                                  />
                                ),
                                field: 'select',
                                render: rowData => (
                                  rowData.statusID === 1 ? (
                                    <Checkbox
                                      checked={isRowSelected(rowData)}
                                      onChange={(event) => handleRowSelect(rowData, event.target.checked)}
                                      color="primary"
                                    />
                                  ) : null
                                ),
                                sorting: false,
                                width: 80
                              },
                              {
                                title: 'Created Date',
                                field: 'effectiveDate',
                                render: rowData =>
                                  rowData.effectiveDate.split('T')[0]
                              },
                              {
                                title: 'Issue Date',
                                field: 'issuingDate',
                                render: rowData =>
                                  rowData.issuingDate.split('T')[0]
                              },
                              { title: 'Route', field: 'routeName' },
                              { title: 'Registration Number', field: 'customerRegistrationNumber' },
                              { title: 'Name', field: 'fullName' },
                              {
                                title: 'Total Amount',
                                field: 'requestedItemTotalPrice',
                                headerStyle: { textAlign: 'center' },
                                cellStyle: { textAlign: 'right', paddingRight: '50px' },
                                render: rowData =>
                                  rowData.requestedItemTotalPrice ? parseFloat(rowData.requestedItemTotalPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"
                              },
                              {
                                title: 'Effective Month',
                                field: 'paymentEffectedMonth',
                              },
                              {
                                title: 'Effective Year',
                                field: 'paymentEffectedYear',
                              },
                              {
                                title: 'Status',
                                field: 'statusID',
                                lookup: {
                                  1: 'Pending',
                                  2: 'Approve',
                                  3: 'Reject',
                                }
                              },
                              {
                                title: 'Actions',
                                field: 'actions',
                                render: rowData => (
                                  <Button
                                    startIcon={<VisibilityIcon fontSize="small" />}
                                    onClick={() => handleClickEdit(rowData)}
                                  >
                                  </Button>
                                ),
                                sorting: false,
                                width: 120
                              }
                            ]}
                            data={factoryAdjustmentData}
                            options={{
                              selection: false,
                              exportButton: false,
                              showTitle: false,
                              headerStyle: { textAlign: 'left', height: '1%' },
                              cellStyle: { textAlign: 'left' },
                              columnResizable: false,
                              actionsColumnIndex: 0,
                              pageSize: pageSize,
                              page: page,
                            }}
                            onChangePage={page => setPage(page)}
                          />
                          <div style={{
                            padding: '10px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: '1px solid #e0e0e0',
                          }}>
                            Selected: {selectedRows.length} row(s)
                          </div></>
                        ) : null}

                        {factoryItemRequestData?.length > 0 && (
                          <Dialog
                            open={viewDialogOpen}
                            onClose={() => setViewDialogOpen(false)}
                            maxWidth="lg"
                            fullWidth
                          >
                            <DialogTitle>
                              Invoice Details -{factoryItemRequestData[0].requestNumber}
                            </DialogTitle>
                            <DialogContent>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Created Date</TableCell>
                                    <TableCell>Issue Date</TableCell>
                                    <TableCell>Route</TableCell>
                                    <TableCell>Reg No</TableCell>
                                    <TableCell>Factory Item</TableCell>
                                    <TableCell>Supplier Name</TableCell>
                                    <TableCell>Quantity</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>No of Installements</TableCell>
                                    <TableCell>Status</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {factoryItemRequestData[0].factoryItemDetailsList.map((item, index) => (
                                    <TableRow key={index}>
                                      <TableCell>
                                        {item.effectiveDate.split('T')[0]}
                                      </TableCell>
                                      <TableCell>
                                        {item.issuingDate.split('T')[0]}
                                      </TableCell>
                                      <TableCell>
                                        {item.routeName}
                                      </TableCell>
                                      <TableCell>
                                        {item.customerRegistrationNumber}
                                      </TableCell>
                                      <TableCell>
                                        {item.itemName}
                                      </TableCell>
                                      <TableCell>
                                        {item.supplierName}
                                      </TableCell>
                                      <TableCell>
                                        {item.requestedItemTotalQuantity}
                                      </TableCell>
                                      <TableCell align={'right'}>
                                        {item.unitPrice ? parseFloat(item.unitPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
                                      </TableCell>
                                      <TableCell>
                                        {item.noOfInstallments}
                                      </TableCell>
                                      <TableCell>
                                        {item.statusID === 1
                                          ? 'Pending'
                                          : item.statusID === 2
                                            ? 'Issue'
                                            : item.statusID === 3
                                              ? 'Reject'
                                              : '-'}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </DialogContent>
                          </Dialog>
                        )}
                        <Dialog
                          open={warningDialogOpen}
                          onClose={() => setWarningDialogOpen(false)}
                          maxWidth="md"
                          fullWidth
                        >
                          <DialogTitle style={{ color: "#d32f2f" }}>Insufficient Stock</DialogTitle>
                          <DialogContent>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Factory Item Name</TableCell>
                                  <TableCell>Supplier Name</TableCell>
                                  <TableCell align="right">Available Quantity</TableCell>
                                  <TableCell align="right">Total Requested Quantity</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {insufficientStockItems.map((item, index) => (
                                  <TableRow key={index}>
                                    <TableCell>{item.itemName}</TableCell>
                                    <TableCell>{item.supplierName}</TableCell>
                                    <TableCell align="right">{item.availableQuantity}</TableCell>
                                    <TableCell align="right" style={{ color: "red" }}>
                                      {item.totalRequested}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => setWarningDialogOpen(false)}
                              color="primary"
                            >
                              CANCEL
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Box>
                    </PerfectScrollbar>
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        className={classes.btnSendToApprove}
                        onClick={() => handleApprove(selectedRows)}
                        disabled={selectedRows.length === 0}
                      >
                        Approve
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        className={classes.btnReject}
                        onClick={() => handleReject(selectedRows)}
                        disabled={selectedRows.length === 0}
                      >
                        Reject
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
